<template>
  <div class="result-box">
    <div class="result-inner">
      <div class="main-text" v-show="!showOverTime && showSuccess">
        <img src="@/assets/waiting.png" alt="">
        <div class="title">预约已提交, 等待审核</div>
        <div class="sub-text gray">审核通过后系统将会发送短信至预约手机号上<br>请注意查收</div>
      </div>
      <div class="result-detail" v-show="!showOverTime && showSuccess">
        <div class="label">预约信息</div>
        <div class="detail-list">
          <div class="detail-item">
            <span class="gray">姓名</span>
            <span>{{successParams.name}}</span>
          </div>
          <div class="detail-item">
            <span class="gray">电话</span>
            <span>{{successParams.phone}}</span>
          </div>
          <div class="detail-item">
            <span class="gray">邮箱</span>
            <span>{{successParams.email}}</span>
          </div>
          <div class="detail-item">
            <span class="gray">场次</span>
            <span>{{successParams.subscribeValue}}</span>
          </div>
        </div>
      </div>
      <div class="main-text" v-show="!showOverTime && showFail">
      <!-- <div class="main-text"> -->
        <img src="@/assets/error-result.png" alt="">
        <div class="title">抱歉，预约失败</div>
        <div class="sub-text gray"  v-show="failParams.status !== 3">{{failParams.message}}</div>
        <div class="sub-text gray" v-show="failParams.status == 3">您当前使用的手机号码尚未进入拟笔试/面试/复试名单</div>
        <div class="sub-text-operation"  v-show="failParams.status == 3">
          <div class="sub-text-title">您可以：</div>
          <div class="sub-text-detail">
            <div>1、使用简历上的手机号码重新预约 <span class="text-btn" @click="goHome">重新预约</span></div>
            <div>2、我们已将信息反馈给hr,经hr确认后再次预约</div>
          </div>
        </div>
      </div>
      <div class="main-text" v-show="showOverTime" style="padding: 100px 0">
        <!-- <img src="@/assets/error-result.png" alt=""> -->
        <div class="title">页面已过期</div>
        <div class="sub-text gray">请返回首页进行预约或查询</div>
        <div class="back-btn" @click="goHome">返回首页</div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import {calendar,inlineCalendar} from 'vue-mobile-calendar';

export default {
  name: 'Result',
  components: {},
  data() {
    return {
      showOverTime: false,
      showSuccess: false,
      showFail: false,
      successParams: {
        name: '',
        phone: '',
        email: '',
        subscribeValue: '',
      },
      failParams: {
        message: ''
      }
    };
  },
  mounted () {
    if(!this.$route.params.type){
      this.showOverTime = true
    }else{
      if(this.$route.params.type == 'success'){
        this.showSuccess = true
        this.successParams = this.$route.params
      }
      if(this.$route.params.type == 'fail'){
        this.showFail = true
        this.failParams = this.$route.params
      }
    }
  },
  methods: {
    goHome () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
<style scoped>
  .result-box{
    min-height: 100vh;
    background: #f5f5f5;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .result-inner{
    background: #fff;
    width: calc(100% - 20px);
    margin: 0 auto;
    border-radius: 4px;
  }
  .main-text{
    padding: 20px;
    text-align: center;
    border-bottom: 1px solid #F2F6FC;
  }
  .main-text img{
    width: 64px;
    height: 64px;
    margin-bottom: 12px;
  }
  .main-text .title{
    font-size: 18px;
    font-weight: bold;
  }
  .main-text .sub-text{
    font-size: 13px;
  }
  .result-detail{
    text-align: left;
    padding-top: 20px;
  }
  .result-detail .label{
    color: #fff;
    background: #3296FF;
    display: inline-block;
    font-size: 13px;
    padding: 4px 12px;
    border-radius: 100px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .detail-list{
    text-align: left;
    font-size: 13px;
    padding: 20px;
  }
  .detail-list .gray{
    margin-right: 12px;
  }
  .back-btn{
    font-size: 14px;
    padding: 4px 12px;
    background: #3296FF;
    border-radius: 4px;
    color: #fff;
    margin-top: 12px;
    display: inline-block;
  }
  .sub-text-operation{
    display: flex;
    align-items: baseline;
    background: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
  }
  .sub-text-operation{
    font-size: 13px;
    margin-top: 20px;
  }
  .sub-text-title{
    min-width: 60px;
  }
  .sub-text-detail{
    text-align: left;
  }
  .text-btn{
    color: #3296FF;
  }
</style>

